export enum FavoritesIconEnum {
  FILLED = 'reaction-love-fill',
  OUTLINED = 'reaction-love-outline',
}
